import { useState, useRef, useEffect } from "react";
import { Winner } from "../../types";
import WinnerSelect from "../winner/WinnerSelect";
import DateScope from "../date/DateScope";
import useContainerResize from "../../hooks/useContainerResize";
import { BREAKPOINT } from "../../util";

type GraphSectionProps = {
  winners: Winner[];
  selectedWinners: Winner[];
  setSelectedWinners: React.Dispatch<React.SetStateAction<Winner[]>>;
  setStartDate: React.Dispatch<React.SetStateAction<string>>;
  setEndDate: React.Dispatch<React.SetStateAction<string>>;
};

function GraphOptions({
  winners,
  selectedWinners,
  setSelectedWinners,
  setStartDate,
  setEndDate,
}: GraphSectionProps) {
  const containerRef = useRef<HTMLElement>(
    document.querySelector(".us-elections-widget__container")
  );
  const [containerWidth, setContainerWidth] = useState<number>(
    containerRef.current?.clientWidth || 0
  );
  const [isWinnerSelectVisible, setIsWinnerSelectVisible] =
    useState<boolean>(false);
  const [isDateScopeVisible, setIsDateScopeVisible] = useState<boolean>(false);

  useContainerResize(containerRef.current, (containerWidth) => {
    setContainerWidth(containerWidth);
  });

  useEffect(() => {
    setIsWinnerSelectVisible(containerWidth >= BREAKPOINT);
    setIsDateScopeVisible(containerWidth >= BREAKPOINT);
  }, [containerWidth]);

  return (
    <>
      <div
        className="us-elections-widget__graph-options-toggles"
        style={{
          display: containerWidth < BREAKPOINT ? "grid" : "none",
        }}
      >
        <button
          onClick={() => {
            setIsDateScopeVisible(false);
            setIsWinnerSelectVisible(!isWinnerSelectVisible);
          }}
          data-is-option-visible={isWinnerSelectVisible ? "true" : "false"}
        >
          Selected candidates ({selectedWinners.length})
        </button>
        <button
          onClick={() => {
            setIsWinnerSelectVisible(false);
            setIsDateScopeVisible(!isDateScopeVisible);
          }}
          data-is-option-visible={isDateScopeVisible ? "true" : "false"}
        >
          Selected period of time
        </button>
      </div>
      <div className="us-elections-widget__graph-options">
        <DateScope
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          isScopeVisible={isDateScopeVisible}
          containerWidth={containerWidth}
        />
        <WinnerSelect
          winners={winners}
          selectedWinners={selectedWinners}
          setSelectedWinners={setSelectedWinners}
          isSelectVisible={isWinnerSelectVisible}
          containerWidth={containerWidth}
        />
      </div>
    </>
  );
}

export default GraphOptions;
